"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.USER_INFO_TEXT = exports.USER_INFO = exports.BOTTOM_MENU_LINKS = exports.TOP_MENU_LINKS = exports.MENU_EXPANDED_CONTAINER = exports.GLOBAL_SEARCH_ACTIVE = exports.GLOBAL_SEARCH = exports.CLOSE_BTN = exports.MENU_EXPANDED_HEADER = exports.MENU = exports.MENU_CONTAINER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var MINIMISED_HEIGHT = "60px",
    MENU_TRANSITION = {
  transition: "height .3s ease-in-out"
},
    MENU_PADDING = {
  padding: "10px 20px"
},
    FIXED_MENU = {
  position: "fixed",
  background: "inherit",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10
},
    MENU_CONTAINER = function MENU_CONTAINER(a) {
  return (0, _cxs["default"])({
    background: a ? _vars.FLATTENED_COLOURS[a] : _vars.COLOURS.mono.white,
    width: "100%",
    height: MINIMISED_HEIGHT
  });
};

exports.MENU_CONTAINER = MENU_CONTAINER;
var MENU = (0, _cxs["default"])(_objectSpread(_objectSpread(_objectSpread({
  boxSizing: "border-box",
  flexDirection: "row",
  display: "flex",
  color: _vars.COLOURS.mono.white,
  height: "60px"
}, FIXED_MENU), MENU_PADDING), {}, {
  " > *:last-child": {
    marginLeft: "auto"
  }
}));
exports.MENU = MENU;
var MENU_EXPANDED_HEADER = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "60px",
  minHeight: "60px"
});
exports.MENU_EXPANDED_HEADER = MENU_EXPANDED_HEADER;
var CLOSE_BTN = (0, _cxs["default"])({
  cursor: "pointer",
  flex: 1,
  justifyContent: "start",
  height: "60px",
  marginRight: "50px"
});
exports.CLOSE_BTN = CLOSE_BTN;
var GLOBAL_SEARCH = (0, _cxs["default"])({
  color: _vars.COLOURS.mono.white,
  width: "40px",
  marginRight: "30px",
  transition: "width .6s",
  marginLeft: "20px",
  borderRadius: "6px",
  " > .icon-container:last-of-type:not(:first-of-type)": {
    right: "15px !important"
  },
  " input": {
    backgroundColor: "transparent",
    color: _vars.COLOURS.mono.black,
    paddingRight: "15px !important",
    borderRadius: "6px",
    height: "100%",
    minHeight: "100%",
    "::placeholder": {
      color: _vars.COLOURS.grey.regent
    }
  }
});
exports.GLOBAL_SEARCH = GLOBAL_SEARCH;
var GLOBAL_SEARCH_ACTIVE = (0, _cxs["default"])({
  width: "100% !important",
  background: _vars.COLOURS.grey.athens.bigFat,
  paddingRight: "20px"
});
exports.GLOBAL_SEARCH_ACTIVE = GLOBAL_SEARCH_ACTIVE;

var MENU_EXPANDED_CONTAINER = function MENU_EXPANDED_CONTAINER(a) {
  return (0, _cxs["default"])(_objectSpread(_objectSpread({
    display: "flex",
    flexDirection: "column",
    height: a ? 0 : "100%",
    padding: "0 20px",
    overflow: "hidden",
    zIndex: 1500,
    boxSizing: "border-box",
    width: "100%",
    bottom: 0
  }, FIXED_MENU), MENU_TRANSITION));
};

exports.MENU_EXPANDED_CONTAINER = MENU_EXPANDED_CONTAINER;
var TOP_MENU_LINKS = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflowY: "auto",
  marginBottom: "35px",
  marginTop: "20px",
  " > button": {
    minHeight: "40px",
    height: "40px"
  }
});
exports.TOP_MENU_LINKS = TOP_MENU_LINKS;
var BOTTOM_MENU_LINKS = (0, _cxs["default"])({
  marginBottom: "20px",
  " > button": {
    minHeight: "40px",
    height: "40px"
  }
});
exports.BOTTOM_MENU_LINKS = BOTTOM_MENU_LINKS;

var USER_INFO = function USER_INFO(a) {
  var b = a.primaryLinksColour;
  return (0, _cxs["default"])({
    display: "flex",
    paddingLeft: "20px",
    marginBottom: "20px",
    " .text": {
      color: b || void 0
    }
  });
};

exports.USER_INFO = USER_INFO;
var USER_INFO_TEXT = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  marginLeft: "20px"
});
exports.USER_INFO_TEXT = USER_INFO_TEXT;